import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class AgentVaAppelerClientPourAccesSiteEvent extends UserEvent {
  public static NAME = 'AGENT_VA_APPELLER_CLIENT_POUR_ACCES_SITE_EVENT';

  constructor(
    public idCreneau: string,
    coordinates?: Coordinates
  ) {
    super(AgentVaAppelerClientPourAccesSiteEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: AgentVaAppelerClientPourAccesSiteEvent): AgentVaAppelerClientPourAccesSiteEvent {
    return new AgentVaAppelerClientPourAccesSiteEvent(obj.idCreneau, obj.coordinates);
  }
}
